import React from 'react'
import { Box, Checkbox, FormControlLabel, Grid, Typography, TextField, Avatar } from '@material-ui/core'

function ViewBusinessForm1() {
  const employeeTypeOptions = [
    { label: 'Indoor Sales', value: 'INDOOR SALES' },
    { label: 'Outdoor Sales', value: 'OUTDOOR SALES' },
  ]
  const inputValues = [
    //    { label: '', value: profilePicture, name: 'profilePicture' },
    { label: 'First Name ', value: 'dummy' },
    { label: 'Last Name ', value: 'dummy' },

    { label: 'Email ', value: 'dummy' },

    { label: 'Company Name', value: 'dummy' },
    { label: 'No. of Employees', value: 'dummy' },
    { label: 'Domain', value: 'dummy' },
  ]
  const item = {
    label: 'Phone Number',
    value: "Dummy",
    name: 'phone',
  }

  return (
    <Grid container>
      <Grid item lg={4} container>
        <Grid item lg={12} />
        <Grid item lg={12} style={{ marginTop: '30px' }}>
          <Avatar />
        </Grid>
        <Grid item lg={12} style={{ paddingTop: '45px' }}>
          <Typography>{item.label}</Typography>
          <Typography>{item.value}</Typography>
        </Grid>
      </Grid>
      <Grid item lg={8} container>
        {inputValues.map((item, index) => (
          <Grid item lg={6} style={{ paddingTop: '25px' }}>
            <Typography>{item.label}</Typography>
            <Typography>{item.value}</Typography>
          </Grid>
        ))}
      </Grid>
    </Grid>
  )
}

export default ViewBusinessForm1
